module.exports = __webpack_public_path__ + "img/8a97c07c25d8643977138eb47d27b3ba.8a97c07c.png";